/**
 *
 * Asynchronously loads the component for InitiativeDetails
 *
 */

import { lazyLoad } from 'utils/loadable';

export const InitiativeDetails = lazyLoad(
  () => import('./index'),
  module => module.InitiativeDetails,
);
